import { servicesData } from "./servicesData";
// import doctorImage from '../../public/images/deokarmam.jpg';

// process.env.PUBLIC_URL + "/images/deokarmam.jpg"

export const siteContent = {
 branding: {
  name: "SURYA DIAGNOSTICS",
  tagline: "उच्च तंत्रज्ञान | अनुभवी डॉक्टर | अचूक निदान",
  phones: [
    "8181817824",
    "8181817834",
    "8181817822"
  ],
  email: "info@suryadiagnosticscenter.com",
  address: "S16/17, 2nd Flooor, Destination Center1, Nanded City, Pune-411041"
},
  
  hero: {
    title: "SURYA DIAGNOSTICS",
    subtitle: "State-of-the-art medical imaging and laboratory services with precision and care",
    cta: "Book Appointment",
    features: [
      { icon: "Shield", text: "ISO Certified" },
      { icon: "Clock", text: "24/7 Emergency" },
      { icon: "Award", text: "Expert Team" },
      { icon: "Zap", text: "Fast Reports" }
    ]
  },

  about: {
    title: "About Surya Diagnostics",
    description: "With over 15 years of excellence in diagnostic healthcare, Surya Diagnostics stands as a beacon of trust and precision in medical diagnostics. Our state-of-the-art facility combines cutting-edge technology with compassionate care to deliver accurate results when they matter most.",
    stats: [
      { number: "50,000+", label: "Patients Served" },
      { number: "15+", label: "Years Experience" },
      { number: "25+", label: "Expert Team" },
      { number: "99%", label: "Accuracy Rate" }
    ],
    images: [
     
      process.env.PUBLIC_URL + "/images/023.jpg",
      process.env.PUBLIC_URL + "/images/022.jpg",
      process.env.PUBLIC_URL + "/images/021.jpg",
      process.env.PUBLIC_URL + "/images/Post 08.png",
      process.env.PUBLIC_URL + "/images/Post 09.png",
      process.env.PUBLIC_URL + "/images/Post 11.png",
      
    ]
  },

  services:servicesData,

  whyChooseUs: [
    {
      icon: "Award",
      title: "ISO Certified",
      description: "Quality management systems certified by international standards"
    },
    {
      icon: "Users",
      title: "Expert Team",
      description: "Highly qualified radiologists, pathologists, and technicians"
    },
    {
      icon: "Clock",
      title: "Quick Reports",
      description: "Fast turnaround time with digital report delivery"
    },
    {
      icon: "Shield",
      title: "Accurate Results",
      description: "99%+ accuracy rate with quality control measures"
    },
    // {
    //   icon: "BadgeCheck",
    //   title: "NABL Accredited",
    //   description: "Laboratory accredited by National Accreditation Board"
    // },
    {
      icon: "IndianRupee",
      title: "Affordable Pricing",
      description: "Competitive rates with various health packages"
    },
    {
      icon: "Smartphone",
      title: "Digital Reports",
      description: "Online report access and home sample collection"
    }
  ],

  specialtyClinics: [
    {
      name: "Diabetes Care Clinic",
      icon: "Activity",
      description: "Comprehensive diabetes management and prevention",
      details: "Expert diabetologists providing personalized care for Type 1 and Type 2 diabetes. Services include HbA1c monitoring, insulin management, dietary counseling, and complication screening. Regular follow-ups and patient education programs.",
      services: ["Blood Sugar Monitoring", "HbA1c Testing", "Insulin Management", "Dietary Counseling", "Foot Care", "Eye Screening", "Kidney Function Tests", "Neuropathy Assessment"]
    },
    {
      name: "Cardiac Care Center",
      icon: "Heart",
      description: "Complete heart health evaluation and treatment",
      details: "Experienced cardiologists offering comprehensive cardiac care. From routine checkups to advanced cardiac diagnostics. Preventive cardiology, risk assessment, and management of heart conditions.",
      services: ["ECG & Echo", "Stress Testing", "Holter Monitoring", "Cardiac CT", "Lipid Management", "Hypertension Control", "Heart Failure Clinic", "Preventive Cardiology"]
    },
    {
      name: "Women's Wellness Clinic",
      icon: "User",
      description: "Specialized healthcare for women at every stage",
      details: "Dedicated women's health services with experienced gynecologists. Comprehensive care from adolescence through menopause. Focus on preventive care, reproductive health, and wellness.",
      services: ["Annual Checkups", "Pregnancy Care", "Hormonal Disorders", "PCOS Management", "Menopause Care", "Breast Health", "Fertility Assessment", "Cancer Screening"]
    },
    {
      name: "Bone & Joint Clinic",
      icon: "Bone",
      description: "Orthopedic care and bone health management",
      details: "Expert orthopedic consultations and bone health services. Specializing in osteoporosis, arthritis, sports injuries, and joint problems. BMD scanning and fracture risk assessment.",
      services: ["Bone Density Scans", "Arthritis Management", "Sports Injuries", "Osteoporosis Treatment", "Joint Pain Relief", "Fracture Assessment", "Vitamin D Therapy", "Physiotherapy Referrals"]
    },
    {
      name: "Thyroid Care Center",
      icon: "Pill",
      description: "Specialized thyroid disorder management",
      details: "Comprehensive thyroid care by endocrinologists. Diagnosis and treatment of hypo/hyperthyroidism, thyroid nodules, and autoimmune conditions. Regular monitoring and medication management.",
      services: ["Thyroid Function Tests", "Ultrasound Thyroid", "FNAC Guidance", "Medication Management", "Thyroid Nodule Evaluation", "Pregnancy Thyroid Care", "Autoimmune Testing", "Follow-up Care"]
    },
    {
      name: "Preventive Health Clinic",
      icon: "ShieldCheck",
      description: "Proactive health management and disease prevention",
      details: "Focus on preventing diseases before they start. Comprehensive health risk assessments, lifestyle counseling, and vaccination programs. Personalized wellness plans based on your health profile.",
      services: ["Health Risk Assessment", "Executive Checkups", "Vaccination Programs", "Lifestyle Counseling", "Nutrition Guidance", "Stress Management", "Weight Management", "Cancer Screening"]
    }
  ],

  testimonials: [
    {
      name: "Rajesh Sharma",
      role: "Business Owner",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh",
      rating: 5,
      text: "Excellent diagnostic center with state-of-the-art equipment. The staff is professional and the reports are delivered on time. Highly recommended for all diagnostic needs."
    },
    {
      name: "Priya Deshmukh",
      role: "Software Engineer",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priya",
      rating: 5,
      text: "I had my complete health checkup done here. The entire process was smooth and hassle-free. Dr. Patel explained all my reports in detail. Very satisfied with the service."
    },
    {
      name: "Amit Kulkarni",
      role: "Retired Teacher",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Amit",
      rating: 5,
      text: "Best diagnostic center in Pune! Quick appointments, accurate results, and caring staff. The senior citizen package was comprehensive and reasonably priced."
    },
    {
      name: "Sneha Patil",
      role: "Homemaker",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sneha",
      rating: 5,
      text: "Very impressed with the women's health package. The gynecologist was very understanding and the entire staff made me feel comfortable. Thank you Surya Diagnostics!"
    },
    {
      name: "Vikram Joshi",
      role: "Marketing Manager",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Vikram",
      rating: 5,
      text: "Got my father's cardiac checkup done here. The cardiology team is excellent and the equipment is top-notch. Very professional service and timely reports."
    },
    {
      name: "Meera Rao",
      role: "Doctor",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Meera",
      rating: 5,
      text: "As a medical professional, I can vouch for the quality of diagnostics at Surya. Their pathology lab is NABL accredited and the reports are accurate. Great facility!"
    }
  ],

  directorsMessage: {
    name: "Dr. RAJLAXMI DEOKAR",
    title: "MBBS, DMRD, DNB (RADIOLOGIST)",
    image: process.env.PUBLIC_URL + "/images/deokarmam.jpg",
    message: "Specialist in sonography and colour Doppler. Fetal medicine specialist. Women's imaging specialist. Experience in X-ray, USG, Doppler CT scan, and MRI since 2005. Diplomat of National board New Delhi. Fellow of fetal medicine foundation the UK. Member of Indian Radiology and Imaging Association (IRIA). Ex consultant Inlaks Budhrani & Mai Mangeshkar hospital.",
    detailedMessage: "Health care has been the utmost important factor of mankind, and will always continue to be till life exists around the globe.\n\nThe basic requirement of any individual is to get a primary and basic health facility in a minimum period.\n\nWe always aimed to bring all the Medical Facilities required for people under One-Roof.\n\nWith this vision, a baby was born under the name of 'SURYA DIAGNOSTICS'.\n\nAt SURYA, we have highly advanced state-of-the-art facilities like Advanced 3D CT Scan, Digital X-Ray, 3D/4D Sonography, and all other types of sonographies, obstetrics /Pregnancy sonography, anomaly scan, NT Scan, 2D Echo, Path Lab, ECG, TMT, BMD, etc.\n\nWe have a team of expert and qualified Radiologists, Doctors, skilled Technicians, and Pathologists at Surya Diagnostics.\n\nWe ensure the most reliable and timely reports in advanced labs which would help the Doctors and Patients to move ahead on the right path to Diagnosis.\n\nWe are glad to have served more than 50,000 patients to date. We will strive much harder to achieve our goal to give every individual access to high-quality diagnosis.\n\nWe would like to thank our team and staff at SURYA DIAGNOSTICS, who continuously support us throughout our journey in building the goodwill and reputation of the center."
  },

  events: [
    {
      id: 1,
      title: "World Heart Day Celebration",
      date: "September 29, 2024",
      image: "https://images.pexels.com/photos/6812502/pexels-photo-6812502.jpeg",
      description: "Free cardiac health screening camp with expert cardiologist consultations and ECG testing for 200+ participants."
    },
    {
      id: 2,
      title: "Diabetes Awareness Camp",
      date: "November 14, 2024",
      image: "https://images.pexels.com/photos/4033023/pexels-photo-4033023.jpeg",
      description: "Comprehensive diabetes screening, dietary counseling, and patient education sessions attended by 300+ people."
    },
    {
      id: 3,
      title: "Women's Health Workshop",
      date: "March 8, 2024",
      image: "https://images.pexels.com/photos/3259624/pexels-photo-3259624.jpeg",
      description: "Interactive workshop on women's wellness with free health screenings and expert gynecologist consultations."
    },
    {
      id: 4,
      title: "Cancer Awareness Drive",
      date: "February 4, 2024",
      image: "https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg",
      description: "Educational seminar on cancer prevention with free screening tests and early detection guidance."
    },
    {
      id: 5,
      title: "Senior Citizens Health Camp",
      date: "October 1, 2024",
      image: "https://images.pexels.com/photos/287237/pexels-photo-287237.jpeg",
      description: "Special health checkup camp for senior citizens with bone density scans and complete health assessment."
    },
    {
      id: 6,
      title: "Blood Donation Camp",
      date: "June 14, 2024",
      image: "https://images.pexels.com/photos/6235665/pexels-photo-6235665.jpeg",
      description: "Voluntary blood donation drive in association with local blood bank. Over 150 units collected."
    }
  ],

  gallery: [
    {
      id: 1,
      title: "Modern CT Scan Suite",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/022.jpg"
    },
    {
      id: 2,
      title: "NABL Accredited Laboratory",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/023.jpg",
    },
    {
      id: 3,
      title: "Cardiac Diagnostic Center",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/021.jpg",
    },
    {
      id: 4,
      title: "Digital X-Ray Unit",
      category: "Facility",
      image: process.env.PUBLIC_URL + "/images/facility1.jpg",
    },
    {
      id: 5,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility2.jpg",
    },
     {
      id: 6,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility3.jpg",
    },
       {
      id: 7,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility4.jpg",
    },
     {
      id: 8,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility5.jpg",
    },
     {
      id: 9,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility6.jpg",
    },
     {
      id: 10,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility7.jpg",
    },
     {
      id: 11,
      title: "Ultrasound Department",
      category: "Facility",
      image:  process.env.PUBLIC_URL + "/images/facility8.jpg",
    },
    {
      id: 12,
      title: "World Heart Day Event",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event1.jpeg",
    },
    {
      id: 13,
      title: "Diabetes Awareness Camp",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event2.jpg",
    },
    {
      id: 14,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event3.jpg",
    },
    {
      id: 15,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event4.jpg",
    },
     {
      id: 16,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event5.jpg",
    },
     {
      id: 17,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event6.jpg",
    },
    {
      id: 18,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event7.jpg",
    },
    {
      id: 19,
      title: "Women's Health Workshop",
      category: "Event",
      image:  process.env.PUBLIC_URL + "/images/event8.jpg",
    },

  ],

  faqs: [
    {
      question: "What are your operating hours?",
      answer: "We are open Monday to Saturday from 7:00 AM to 9:00 PM, and Sunday from 8:00 AM to 2:00 PM. Emergency services are available 24/7."
    },
    {
      question: "Do I need an appointment for tests?",
      answer: "While walk-ins are welcome, we recommend booking an appointment for faster service, especially for imaging tests like CT scans and MRI. You can book online or call us."
    },
    {
      question: "How quickly will I receive my reports?",
      answer: "Most pathology reports are available within 24 hours. X-rays and ultrasounds are reported the same day. CT scans and specialty tests may take 24-48 hours. Digital reports are sent via email and WhatsApp."
    },
    {
      question: "Do you offer home sample collection?",
      answer: "Yes, we provide free home sample collection for pathology tests. Book online or call us to schedule a convenient time for sample pickup."
    },
    {
      question: "Are your labs accredited?",
      answer: "Yes, our pathology laboratory is NABL (National Accreditation Board for Testing and Calibration Laboratories) accredited, ensuring the highest quality standards."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept cash, credit/debit cards, UPI, and all major digital payment methods. We also accept insurance claims from major insurance providers."
    },
    {
      question: "Do you accept insurance?",
      answer: "Yes, we are empaneled with most major insurance companies and TPAs. Please bring your insurance card and policy details for cashless facility."
    },
    {
      question: "What should I bring for my appointment?",
      answer: "Please bring your prescription/doctor's referral, previous reports (if any), valid ID proof, and insurance card if applicable."
    },
    {
      question: "Do you provide consultation services?",
      answer: "Yes, we have specialist consultations available in cardiology, radiology, pathology, and other specialties. Appointments can be booked online or by phone."
    },
    {
      question: "What preparation is needed for fasting blood tests?",
      answer: "For fasting blood tests, avoid eating or drinking anything except water for 8-12 hours before the test. You can take your regular medications unless advised otherwise."
    },
    {
      question: "Can I get a full body checkup?",
      answer: "Yes, we offer comprehensive health checkup packages for different age groups and health needs. Our executive, cardiac, diabetes, and other packages provide complete health assessment."
    },
    {
      question: "Is parking available?",
      answer: "Yes, we have ample parking space available for patients and visitors at no charge."
    }
  ],

  blogs: [
    {
      id: 1,
      title: "Understanding the Importance of Regular Health Checkups",
      excerpt: "Learn why annual health screenings are crucial for early disease detection and maintaining optimal health throughout your life.",
      author: "Dr. Meera Patel",
      date: "January 15, 2025",
      image: "https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg",
       category: "Preventive Care",
      readTime: "5 min read",
      link: "https://example.com/blog/importance-regular-checkups"
    },
    {
      id: 2,
      title: "Heart Health: 10 Warning Signs You Shouldn't Ignore",
      excerpt: "Recognize the early warning signs of heart disease and when to seek immediate medical attention for cardiac symptoms.",
      author: "Dr. Rajesh Kumar",
      date: "January 10, 2025",
      image: "https://images.pexels.com/photos/6812502/pexels-photo-6812502.jpeg",
      category: "Cardiology",
      readTime: "7 min read",
      link: "https://example.com/blog/heart-health-warning-signs"
    },
    {
      id: 3,
      title: "Diabetes Management: Diet and Lifestyle Tips",
      excerpt: "Practical advice on managing diabetes through proper nutrition, exercise, and lifestyle modifications for better blood sugar control.",
      author: "Dr. Anjali Deshmukh",
      date: "January 5, 2025",
      image: "https://images.pexels.com/photos/4033023/pexels-photo-4033023.jpeg",
      category: "Diabetes",
      readTime: "6 min read",
      link: "https://example.com/blog/diabetes-management-tips"
    },
    {
      id: 4,
      title: "Women's Health: Essential Screenings at Every Age",
      excerpt: "A comprehensive guide to important health screenings women should undergo at different life stages for optimal wellness.",
      author: "Dr. Priya Sharma",
      date: "December 28, 2024",
      image: "https://images.pexels.com/photos/3259624/pexels-photo-3259624.jpeg",
      category: "Women's Health",
      readTime: "8 min read",
      link: "https://example.com/blog/womens-health-screenings"
    },
    {
      id: 5,
      title: "Understanding CT Scans: What to Expect During Your Test",
      excerpt: "Everything you need to know about CT scan procedures, preparation, and what happens during the imaging process.",
      author: "Dr. Vikram Joshi",
      date: "December 20, 2024",
      image: "https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg",
      category: "Radiology",
      readTime: "5 min read",
      link: "https://example.com/blog/understanding-ct-scans"
    },
    {
      id: 6,
      title: "Bone Health: Preventing Osteoporosis as You Age",
      excerpt: "Learn about maintaining strong bones, risk factors for osteoporosis, and when to get a bone density test.",
      author: "Dr. Amit Kulkarni",
      date: "December 15, 2024",
      image: "https://images.pexels.com/photos/6501931/pexels-photo-6501931.jpeg",
      category: "Bone Health",
      readTime: "6 min read",
      link: "https://example.com/blog/preventing-osteoporosis"
    }
  ],

  autoSlider: [
  {
    id: 1,
    title: "Advanced 3D CT Scan Technology",
    image: process.env.PUBLIC_URL + "/images/ELAST.jpeg" // Update with your image path
  },
  {
    id: 2,
    title: "Digital X-Ray Imaging Suite",
    image: process.env.PUBLIC_URL + "/images/GLS.jpeg" // Update with your image path
  },
  {
    id: 3,
    title: "4D Ultrasound & Doppler Imaging",
    image: process.env.PUBLIC_URL + "/images/HSG.jpeg" // Update with your image path
  },
  {
    id: 4,
    title: "MRI Scanning Center",
    image: process.env.PUBLIC_URL + "/images/Post 16.png" // Update with your image path
  },
],
};
